$(document).ready(function () {
    const targetElement = document.querySelector('.product__container');
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          if (document.querySelector('.product-gallery--loaded-image')) {
            document.querySelector('.gallery_placeholder').remove();
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetElement, config);
    
    function onElementInserted(containerSelector, elementSelector, callback) {
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    $(mutation.addedNodes).find(elementSelector).each(function () {
                        callback($(this));
                    });
                }
            });
        });
        observer.observe($(containerSelector)[0], {childList: true, subtree: true});
    }

    function calculate_ex_vat_price(inc_vat_price, element) {
        const stripped_price = inc_vat_price.replace(/[^0-9\.]/g, '');
        let price = stripped_price / (element.data('product-id') === '6551739269278' ? 1 : 1.2) * 100;
        if (element.data('taxfree')) {
            price = (((stripped_price - tax_free_price) / 1.2) * 100) + (element.data('taxfree') / 100);
        }

        return window.Shopify.formatMoney(price, "£{{amount}}");
    }

    function setup_price(element) {

        if (element.hasClass('atc--product-details--price-discounted')) {
            return;
        }

        if (element.hasClass('pre-money')) {
            update_price(element);
            return;
        }

        const inc_vat_price = element.text(),
            ex_vat_price = calculate_ex_vat_price(inc_vat_price, element),
            additional_classes = '';

        element.addClass('pre-money').addClass('money-hide');

        $('<div class="exemptify_clone ' + additional_classes + '"></div>').insertAfter(element);

        const container = element.next('.exemptify_clone');

        container.append('<span class="exemptify_inc_vat">' + inc_vat_price + ' (Inc VAT)</span><br />');
        container.append('<span class="exemptify_ex_vat" style="color:#727272;font-size: 0.8em;font-weight: normal;">' + ex_vat_price + ' (Ex VAT)</span><br />');
    }

    function update_price(element) {

        if (element.hasClass('atc--product-details--price-discounted')) {
            return;
        }

        if (!element.hasClass('pre-money')) {
            setup_price(element);
            return;
        }

        const container = element.next('.exemptify_clone'),
            inc_vat_price = element.text(),
            ex_vat_price = calculate_ex_vat_price(inc_vat_price, element);

        container.find('.exemptify_inc_vat').text(inc_vat_price + ' (Inc VAT)');
        container.find('.exemptify_ex_vat').text(ex_vat_price + ' (Ex VAT)');
    }

    $('body').find('.money').each(function () {
        setup_price($(this));
    });

    $('body').on('DOMSubtreeModified', '.money', function () {
        update_price($(this));
    });

    $('[data-cartitem-quantity]').change(function () {
        setTimeout(function () {
            $('.cartitems--list').find('.money').each(function () {
                setup_price($(this));
            });
        }, 3000);
    });

});
function toggleDescription() {
  if (document.querySelector('.full-description').style.display === 'block') {
      document.querySelector('.full-description').style.display = '-webkit-box';
      document.querySelector('.toggle-description').textContent = 'Read More';
  } else {
      document.querySelector('.full-description').style.display = 'block';
      document.querySelector('.toggle-description').textContent = 'Read Less';
  }
}